import { render, staticRenderFns } from "./new-member.vue?vue&type=template&id=446d1d04&scoped=true&"
import script from "./new-member.vue?vue&type=script&lang=js&"
export * from "./new-member.vue?vue&type=script&lang=js&"
import style0 from "./new-member.vue?vue&type=style&index=0&id=446d1d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d1d04",
  null
  
)

export default component.exports